import { Box, Button, styledComponent, Typography } from '@hermes/web-components'

export const SortBody = styledComponent(Box)(() => ({
  display: 'flex',
  flexDirection: 'row'
}))

type ButtonProps = typeof Button.arguments
interface StyledButtonProps extends ButtonProps {
  position: 'left' | 'right'
}
export const SortOrFilterButton = styledComponent(Button, {
  shouldForwardProp: (prop) => prop !== 'position'
})<StyledButtonProps>(({ theme, position }) => ({
  display: 'inline-flex',
  fill: theme.palette.primary.main,
  color: theme.palette.primary.main,
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 500,
  ...(position === 'left' ? { marginRight: '5px', justifyContent: position } : {}),
  ...(position === 'right' ? { marginLeft: '5px', justifyContent: position } : {})
}))

export const SortValueContainer = styledComponent(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}))

export const SortValue = styledComponent(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  color: theme.palette.neutral.main
}))

export const SellersTitleContainer = styledComponent(Box)(() => ({
  display: 'flex'
}))

export const SellersTitle = styledComponent(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
  marginTop: '32px',
  marginBottom: '15px',
  fontFamily: 'PT Serif',
  fontWeight: 700,
  fontSize: '28px',
  lineHeight: '36px',

  [theme.breakpoints.down('sm')]: {
    marginBottom: '4px',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px'
  }
}))
